import { computed, Ref, unref } from 'vue';
import { skipToken, useQuery } from '@tanstack/vue-query';
import { fetchScannerCredentialFields } from './scannerCredentialFields.endpoints';
import type { TScannerCredentialFieldsQueryPayload } from '../models/types';
import { getScannerCredentialFieldsQueryKey } from './scannerCredentialFields.queryKeys';

export function useFetchScannerCredentialFields(
  payloadRef: Ref<TScannerCredentialFieldsQueryPayload | null>
) {
  return useQuery({
    queryKey: computed(() => {
      const payload = unref(payloadRef);

      if (!payload) {
        return ['scannerCredentialFields', 'disabled'];
      }

      return getScannerCredentialFieldsQueryKey(payload);
    }),
    queryFn: computed(() => {
      const payload = unref(payloadRef);

      if (!payload) {
        return skipToken;
      }

      if (payload.mode === 'integration' && !payload.integrationId) {
        return skipToken;
      }

      return () => fetchScannerCredentialFields(payload);
    }),
  });
}
